import React, { useState } from "react";
import Papa from "papaparse";
import "./csvuploader.css";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { formatAccountNumber, createCustomer } from "../actions/createCustomer";
import { UserAuth } from "../../../context/AuthContext";
import { Rings } from "react-loader-spinner";

const CsvUploader = ({ setIsOpen }) => {
  const { user } = UserAuth();
  const [csvData, setCsvData] = useState(null);
  const [objectProperties, setObjectProperties] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleFileUpload = (e) => {
    const file = e.target.files[0];

    Papa.parse(file, {
      header: true,
      complete: (results) => {
        // Initialize objectProperties with the column names from the CSV file
        const firstRow = results.data[0];
        const columns = Object.keys(firstRow);
        const initialObjectProperties = columns.map((column) => ({
          column,
          property: "",
          exclude: false,
        }));
        setObjectProperties(initialObjectProperties);

        setCsvData(results.data);
      },
    });
  };

  const handlePropertyChange = (column, e) => {
    const { name, value } = e.target;
    console.log(value);
    setObjectProperties((prevProperties) =>
      prevProperties.map((prop) =>
        prop.column === column ? { ...prop, [name]: value } : prop
      )
    );
  };

  const handleSaveToDatabase = async () => {
    // Map csvData columns to object properties based on the user-selected mappings
    const mappedData = csvData.map((row) => {
      const mappedRow = {};
      objectProperties.forEach(({ column, property, exclude }) => {
        if (exclude) return;
        mappedRow[property] = row[column];
      });
      return mappedRow;
    });
    setLoading(true);
    mappedData.forEach((data) => {
      if (!data.name || !data.email || !data.phone || !data.wholesaleAccount) {
        console.log("Not Found");
        return;
      }

      async function createNewCustomer() {
        try {
          await createCustomer(
            data.name,
            formatAccountNumber(data.wholesaleAccount),
            data.email,
            user.uid,
            data.phone.slice(-10)
          );
        } catch (error) {
          console.log(error);
        }
      }
      createNewCustomer();
    });

    setLoading(false);
    setCsvData(null);
    setObjectProperties([]);
    setIsOpen();
  };

  return (
    <div className="modalFormContainer">
      <input
        className="csv_input"
        type="file"
        accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
        onChange={handleFileUpload}
      />

      {objectProperties.length > 0 && (
        <>
          <p>
            Please match the columns of your CSV file with the Customer
            Property.
          </p>
          <TableContainer
            className="table_conatiner"
            style={{ borderRadius: 4 }}
            sx={{ maxHeight: "450px" }}
          >
            <Table size="small" stickyHeader aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell width={"50%"}>
                    <p className="table-title">CSV Column</p>
                  </TableCell>
                  <TableCell width={"40%"} align="center">
                    <p className="table-title">Customer Property</p>
                  </TableCell>
                  <TableCell width={"10%"} align="center">
                    <p className="table-title">Exclude</p>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {objectProperties.map(({ column, property, exclude }) => (
                  <TableRow key={column}>
                    <TableCell component="th" scope="row">
                      <td>{column}</td>
                    </TableCell>
                    <TableCell align="center">
                      <select
                        className="modalFormInputBox"
                        name="property"
                        value={property}
                        onChange={(e) => handlePropertyChange(column, e)}
                      >
                        <option value="">Select an Option</option>
                        <option value="name">Name</option>
                        <option value="wholesaleAccount">Account Number</option>
                        <option value="email">Email</option>
                        <option value="phone">Mobile Number</option>
                      </select>
                    </TableCell>
                    <TableCell align="center">
                      <input
                        type="checkbox"
                        name="exclude"
                        checked={exclude}
                        onChange={(e) => handlePropertyChange(column, e)}
                      />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

          <button
            className="modalFormInputButton"
            onClick={handleSaveToDatabase}
            disabled={loading}
          >
            {loading ? (
              <div className="csv_loader">
                <Rings
                  height="30"
                  width="30"
                  color="#063970"
                  radius="6"
                  wrapperStyle={{}}
                  wrapperClass=""
                  visible={true}
                  ariaLabel="rings-loading"
                />
              </div>
            ) : (
              "Upload Customers"
            )}
          </button>
        </>
      )}
    </div>
  );
};

export default CsvUploader;
